import { BVAphases } from 'constants/HomeConstants'

interface StepStripProps {
  activeIndex: number
}

export const StepStrip = ({ activeIndex }: StepStripProps) => {
  return (
    <div className="step-strip">
      {BVAphases.map((phase, index) => {
        const isActive = index === activeIndex
        const isLeftFilled = index > 0 && index <= activeIndex
        const isRightFilled = index < activeIndex
        return (
          <div key={phase.title} className={`step-strip-item ${isActive ? 'active' : ''}`}>
            <div className="step-strip-indicator-row">
              <div className={`divider-left ${isLeftFilled ? 'completed' : ''}`} />
              <div className="step-indicator-number subtitle-xxs">{index + 1}</div>
              <div className={`divider-right ${isRightFilled ? 'completed' : ''}`} />
            </div>
            <span className="step-strip-label subtitle-xs">{phase.title}</span>
          </div>
        )
      })}
    </div>
  )
}
